"use client";

import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button, EmptyState, ListSurface, ListSurfaceBody } from "@/components/ui-system";
import { EnterprisePageShell } from "@/components/layout/enterprise-page-shell";
import { logout } from "@/modules/auth/api";
import { useAuthStore } from "@/modules/auth/store";

export function AccessPendingPage() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  async function handleSignOut() {
    try {
      await logout();
    } finally {
      useAuthStore.getState().clearSession();
    }
  }

  return (
    <EnterprisePageShell
      hideHeader
      title="Access Pending"
      description="Your account is active, but no workspace modules have been assigned yet."
    >
      <div className="mx-auto w-full max-w-3xl p-5">
        <ListSurface>
          <ListSurfaceBody>
            <div className="p-6">
              <EmptyState
                icon={Lock}
                title="Sign-up successful"
                description={`${
                  user?.name?.trim() || user?.email || "Your account"
                } can sign in successfully, but no platform permissions are assigned yet. Ask your workspace admin to grant module access before using the console.`}
                action={(
                  <div className="flex flex-wrap justify-center gap-3">
                    <Button type="button" variant="secondary" onClick={() => void handleSignOut()}>
                      Sign out
                    </Button>
                    <Button type="button" onClick={() => navigate("/profile")}>
                      Open profile
                    </Button>
                  </div>
                )}
              />
            </div>
          </ListSurfaceBody>
        </ListSurface>
      </div>
    </EnterprisePageShell>
  );
}

